type Address = {
	addressLineOne?: string | null;
	addressLineTwo?: string | null;
	city?: string | null;
	country?: string | null;
	postalCode?: string | null;
	province?: string | null;
};

export function formatAddress(address: Address): string {
	const parts = [
		address.addressLineOne,
		address.addressLineTwo,
		`${address.postalCode ?? ""} ${address.city ?? ""}`,
		address.province,
	].filter(Boolean);

	return parts.join(", ");
}
